<p-toast [key]="toastKey"> </p-toast>
<div class="UserProfileTabs">
<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>

<div class="bpt-main-content-container" style="overflow: auto;" *ngIf="accessToUserProfile; else UserProfileNotAccesible">
    <div class="grid">
        <div class="col-grow">
            <app-read-only readonlyText="{{userProfile.fullName}}" style="font-size: large;"></app-read-only>
            <app-read-only readonlyText="{{userProfile.eMailAddress}}"></app-read-only>
        </div>
        <div class="col-fixed file-upload">
            <bpt-file-upload
                [uploadFiles]="uploadSucceeds"
                [fileTypes]="''"
                [maxSize]="maxFileSize"
                [fileLimit]="userProfileAttachmentMaxLimit">
            </bpt-file-upload>
        </div>       
    </div>    
    
    <p-tabView [activeIndex]="userProfileActiveTabIndex">
      <p-tabPanel header="Training Plan" *ngIf="userProfileTabAccess?.trainingPlanAccess">
        <app-user-training-plan></app-user-training-plan> 
     </p-tabPanel>
        <p-tabPanel header="User Profile" *ngIf="userProfileTabAccess?.userProfileAccess">
            <app-user-profile-details [userProfile]="userProfile" [treeData]="treeData"></app-user-profile-details>
        </p-tabPanel>
        <p-tabPanel header="My Employees Training Plan" *ngIf="userProfileTabAccess?.myEmployeeTrainingPlanAccess">
            <ng-template pTemplate="header">
              <span class="tab-header-container">
                My Employees Training Plan
                <span class="badge-container">
                    <i class="pi fa fa-eye" pBadge value={{trainingPlanReviewPendingCount}} style="font-size: 1rem; color: orange;"></i>
                </span>
              </span>
            </ng-template>
            <app-employees-training-plan (employeesTrainingPendingCount)="updateTrainingPlanReviewPendingCount($event)"></app-employees-training-plan>
          </p-tabPanel>
          <p-tabPanel header="My Employees Profile" *ngIf="userProfileTabAccess?.myEmployeesProfileAccess">
            <app-my-employees-profile></app-my-employees-profile>
          </p-tabPanel>
    </p-tabView>
</div>

<ng-template #UserProfileNotAccesible>
    <app-error [errorMessage]="userProfileErrorMessage()"></app-error>
  </ng-template>

</div>
